<template>
  <div class v-if="detail != null">
    <Toast />

    <div class="card">
      <h5>
        <b>Edit Kategori</b>
      </h5>
      <FileUpload
        :customUpload="true"
        @uploader="onUpload"
        :multiple="true"
        :disabled="loading.upload"
        accept="image/*"
        :maxFileSize="1000000"
      >
        <template #empty>
          <p>Tarik dan lepas file ke sini untuk mengupload.</p>
        </template>
      </FileUpload>
    </div>

    <div class="card">
      <div class="p-grid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Gambar</th>
                <th>Set Default</th>
                <th>Hapus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in detail.category_images" :key="k">
                <td v-bind:style="{ width: '40%' }">
                  <img
                    :src="an_item.url"
                    :alt="'picture'"
                    v-bind:style="{ width: '50%' }"
                  />
                </td>
                <td v-bind:style="{ width: '40%' }">
                  <Button
                    label="Set Default"
                    v-if="an_item.default === 0"
                    @click="confirmSetDefault(an_item)"
                    class="p-button-success"
                    :disabled="loading.setDefaultButton"
                  ></Button>
                  <Button
                    label="Default"
                    v-if="an_item.default === 1"
                    disabled="disabled"
                  ></Button>
                </td>
                <td v-bind:style="{ width: '40%' }">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    v-if="an_item.default === 0"
                    class="p-button-secondary"
                    @click="confirmDelete(an_item)"
                    :disabled="loading.deleteButton"
                  ></Button>
                </td>
              </tr>
            </tbody>
          </table>

          <Dialog
            :visible.sync="setDefaultDialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Default"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="category_image">
                Apakah kamu ingin menyetel default gambar ini?
              </span>
            </div>
            <template #footer>
              <Button
                label="Tidak"
                icon="pi pi-times"
                class="p-button-text"
                @click="setDefaultDialog = false"
              />
              <Button
                label="Ya"
                icon="pi pi-check"
                class="p-button-text"
                @click="setDefault(category_image.id)"
              />
            </template>
          </Dialog>

          <Dialog
            :visible.sync="deleteDialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Hapus"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="category_image">
                Apakah kamu ingin menghapus gambar ini?
              </span>
            </div>
            <template #footer>
              <Button
                label="Tidak"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteDialog = false"
              />
              <Button
                label="Ya"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteImage(category_image.id)"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="code">Kode</label>
          <InputText
            class="form-control"
            id="code"
            type="text"
            :maxlength="3"
            v-model="inputData.code"
            placeholder="Kode Kategori"
            @keyup.prevent="isError.code = false"
          />
          <small class="p-error" v-if="isError.code">{{
            error_msg.code
          }}</small>
        </div>
      </div>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="name">Nama</label>
          <InputText
            class="form-control"
            id="name"
            type="text"
            v-model="inputData.name"
            placeholder="Nama Kategori"
            @keyup.prevent="isError.name = false"
          />
          <small class="p-error" v-if="isError.name">{{
            error_msg.name
          }}</small>
        </div>
      </div>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="parent">Kelompok Kategori</label> <br />
          <AutoComplete
            placeholder="Pilih Kelompok Kategori"
            id="parent"
            :dropdown="true"
            :multiple="false"
            v-model="inputData.parent"
            :suggestions="autoFilteredValue"
            @complete="searchItem($event)"
            field="name"
          />
          <small class="p-error" v-if="isError.parent">{{
            error_msg.parent
          }}</small>
        </div>
      </div>

      <div class="p-grid p-fluid p-mt-5">
        <div class="p-col-12 p-md-6 p-lg-4">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges"
            :disabled="loading.edit"
          >
            Simpan Kategori
            <span v-if="loading.edit">
              <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
            </span>
          </button>
          <!-- <Button
            type="button"
            style="width: 100%"
            label="Simpan Kategori"
            @click="saveChanges"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expandedRows: [],
      autoFilteredValue: [],
      detail: null,
      category_image: {},
      deleteDialog: false,
      setDefaultDialog: false,
      loading: {
        upload: false,
        setDefaultButton: false,
        deleteButton: false,
        edit: false
      },
      isError: {
        code: false,
        name: false,
        parent: false
      },
      error_msg: {
        parent: '',
        code: '',
        name: ''
      },
      inputData: {
        code: '',
        name: '',
        parent: ''
      },
      dropdownItems: [
        { id: 0, name: 'Name 1' },
        { id: 1, name: 'Name 2' },
        { id: 2, name: 'Name 3' }
      ],
      category_list: [
        {
          dropdownItem: null
        }
      ]
    }
  },
  mounted() {
    this.getDetails()
    this.getListCategory()
  },
  methods: {
    saveChanges() {
      if (this.inputData.code == '') {
        this.isError.code = true
        this.error_msg.code = 'Mohon isi kode'
      }
      if (this.inputData.name == '') {
        this.isError.name = true
        this.error_msg.name = 'Mohon isi nama'
      } else {
        this.inputData.name = this.inputData.name.toUpperCase()
      }
      if (this.inputData.parent) {
        this.inputData.parent_id = this.inputData.parent.id
      }
      this.loading.edit = true
      if (!this.isError.code && !this.isError.name) {
        this.$http
          .put(
            `${process.env.VUE_APP_API_URL}/dashboard/categories/${this.$route.query.id}`,
            this.inputData
          )
          .then(response => {
            this.loading.edit = false
            if (response.status === 200) {
              this.getDetails()
              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil Update Kategori',
                detail: 'Selamat, kategori berhasil di update',
                life: 3000
              })
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal Update Kategori',
                detail: 'Maaf, terdapat masalah ketika meng-update kategori',
                life: 3000
              })
            }
          })
        this.isError = {
          name: false,
          code: false
        }
        this.createDialog = false
      }
    },
    getListCategory() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/dashboard/categories`)
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.dropdownItems = response.data.data.categories
          } else {
            console.error('gagal get')
          }
        })
    },
    searchItem(event) {
      this.autoFilteredValue = this.dropdownItems.filter(item => {
        return item.name.toLowerCase().startsWith(event.query.toLowerCase())
      })
    },
    confirmDelete(category_image) {
      this.category_image = category_image
      this.deleteDialog = true
    },
    deleteImage(id) {
      this.loading.deleteButton = true
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/dashboard/category-images/${id}`
        )
        .then(response => {
          this.loading.deleteButton = false
          this.deleteDialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil Menghapus Gambar',
              detail: '',
              life: 3000
            })
            this.getDetails()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal Menghapus Gambar',
              detail: '',
              life: 3000
            })
          }
        })
    },
    confirmSetDefault(category_image) {
      this.category_image = category_image
      this.setDefaultDialog = true
    },
    setDefault(id) {
      this.loading.setDefaultButton = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/dashboard/category-images/${id}/default`
        )
        .then(response => {
          this.loading.setDefaultButton = false
          this.setDefaultDialog = false
          if (response.status === 200) {
            this.getDetails()
          }
        })
    },
    getDetails() {
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/categories/${this.$route.query.id}`
        )
        .then(response => {
          if (response.status === 200) {
            this.detail = response.data.data
            this.inputData.code = this.detail.category.code
            this.inputData.name = this.detail.category.name
            this.inputData.parent = this.detail.parent
          }
        })
    },

    chooseDropdownChanges(k) {
      console.info(k)
    },

    editCategory() {
      this.$$http
        .put(
          `${process.env.VUE_APP_API_URL}/dashboard/categories/${this.$route.query.id}`,
          this.inputData
        )
        .then(response => {
          this.loading.upload = false
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: 'File Ter-upload',
              life: 3000
            })
            this.getDetails()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal',
              detail: 'File Gagal Ter-upload',
              life: 3000
            })
          }
        })
      this.getDetails()
    },
    onUpload(event) {
      this.loading.upload = true
      var formData = new FormData()
      event.files.forEach(element => {
        formData.append('files', element)
      })

      this.$http
        .post(
          `${process.env.VUE_APP_API_URL}/dashboard/category-images?id=${this.$route.query.id}`,
          formData
        )
        .then(response => {
          this.loading.upload = false
          if (response.status == 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Behasil',
              detail: 'File Ter-upload',
              life: 3000
            })
            this.getDetails()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal',
              detail: 'File Gagal Ter-upload',
              life: 3000
            })
          }
        })
      this.getDetails()
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
